export type NavLink = { id: string; label: string };

export const navLinks: NavLink[] = [
  { id: "overview", label: "作品简介" },
  { id: "channels", label: "渠道类型" },
  { id: "directory", label: "资源导航" },
  { id: "how", label: "查找方法" },
  { id: "search", label: "搜索技巧" },
  { id: "versions", label: "版本说明" },
  { id: "faq", label: "常见问题" },
  { id: "safety", label: "安全提示" },
];

export type QuickFact = { label: string; value: string; icon: string };

export const quickFacts: QuickFact[] = [
  { label: "内容形式", value: "剧集 · 短片 · 合集", icon: "ri-film-line" },
  { label: "常见需求", value: "观看入口 / 全集 / 完整版", icon: "ri-search-eye-line" },
  { label: "主要渠道", value: "在线 · 回看 · 海外 · 网盘", icon: "ri-live-line" },
  { label: "本站定位", value: "渠道整理与观看指引", icon: "ri-compass-3-line" },
];

export type ChannelType = {
  id: string;
  name: string;
  tagline: string;
  icon: string;
  stability: string;
  pros: string;
  cons: string;
  points: string[];
  image: string;
  imageAlt: string;
};

export const channelTypes: ChannelType[] = [
  {
    id: "streaming",
    name: "在线播放平台",
    tagline: "主流正版流媒体的点播入口",
    icon: "ri-play-circle-line",
    stability: "稳定性 高",
    pros: "清晰度与字幕规范，播放顺畅",
    cons: "部分内容需要会员或地区可用",
    points: ["画质统一，支持多清晰度切换", "字幕与配音版本较齐全", "适合希望一次看完整的观众"],
    image:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20abstract%20of%20glowing%20screen%20light%20reflecting%20on%20dark%20surface%20with%20golden%20bokeh%2C%20modern%20streaming%20concept%2C%20elegant%20moody%20tones%2C%20no%20people%2C%20high%20detail%2C%20editorial%20photography&width=600&height=400&seq=jmh-ch-online-01&orientation=landscape",
    imageAlt: "抽象暖色调的在线播放概念图",
  },
  {
    id: "replay",
    name: "电视台官方回看",
    tagline: "依托节目单的往期回看与点播",
    icon: "ri-tv-2-line",
    stability: "稳定性 高",
    pros: "来源可靠，更新与排播基本同步",
    cons: "可回看的档期有限，可能带贴片广告",
    points: ["适合按排播节奏追看", "官方客户端通常免费观看", "片库以本台播出的内容为准"],
    image:
      "https://readdy.ai/api/search-image?query=Retro%20television%20set%20silhouette%20in%20warm%20amber%20light%20with%20soft%20haze%20and%20vintage%20film%20texture%2C%20cozy%20evening%20atmosphere%2C%20cinematic%20dark%20background%2C%20no%20people%2C%20high%20detail%2C%20editorial%20photography&width=600&height=400&seq=jmh-ch-tv-02&orientation=landscape",
    imageAlt: "暖光下的复古电视机剪影概念图",
  },
  {
    id: "overseas",
    name: "海外地区平台",
    tagline: "地区限定上线的多语内容站点",
    icon: "ri-global-line",
    stability: "稳定性 中",
    pros: "片库与大陆平台互补，字幕多语",
    cons: "需要合适的网络环境与地区账号",
    points: ["部分作品仅特定地区可见", "字幕以英文或多语为主", "适合有海外观看条件的用户"],
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20world%20map%20light%20trails%20in%20warm%20gold%20and%20deep%20bronze%20over%20dark%20background%2C%20global%20network%20concept%2C%20elegant%20cinematic%20glow%2C%20no%20people%2C%20high%20detail%2C%20editorial%20photography&width=600&height=400&seq=jmh-ch-global-03&orientation=landscape",
    imageAlt: "金色光轨构成的世界地图概念图",
  },
  {
    id: "netdisk",
    name: "网盘与分享社区",
    tagline: "更新最快但最需要甄别的渠道",
    icon: "ri-cloud-line",
    stability: "稳定性 低",
    pros: "更新快，有时能补足其他平台缺失的版本",
    cons: "链接极易失效，来源无法核实",
    points: ["请勿在陌生页面输入账号密码", "不下载来路不明的可执行文件", "仅作最后的备选渠道"],
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20glowing%20cloud%20and%20data%20particles%20in%20warm%20amber%20and%20terracotta%20tones%20over%20dark%20elegant%20background%2C%20digital%20storage%20concept%2C%20soft%20bokeh%2C%20no%20people%2C%20high%20detail%2C%20editorial%20photography&width=600&height=400&seq=jmh-ch-cloud-04&orientation=landscape",
    imageAlt: "暖橘色调的云端数据概念图",
  },
];

export const directoryCategories = ["全部", "在线播放", "官方回看", "海外平台", "网盘下载"];
export const directoryRegions = ["全部", "大陆", "港台", "日韩", "欧美"];

export type DirectoryItem = {
  name: string;
  category: string;
  region: string;
  stability: "高" | "中" | "低";
  desc: string;
  tags: string[];
};

export const directoryItems: DirectoryItem[] = [
  {
    name: "综合正版视频平台",
    category: "在线播放",
    region: "大陆",
    stability: "高",
    desc: "以会员订阅为主，提供稳定的在线播放服务，清晰度与字幕通常最为规范，适合希望一次就看完整版的观众。",
    tags: ["会员", "高清", "稳定"],
  },
  {
    name: "电视台官方客户端回看",
    category: "官方回看",
    region: "大陆",
    stability: "高",
    desc: "依托电视台节目单，提供往期回看与片段点播，更新与排播基本同步，适合按档期追看的观众。",
    tags: ["回看", "官方", "免费"],
  },
  {
    name: "海外流媒体（地区限定）",
    category: "海外平台",
    region: "欧美",
    stability: "中",
    desc: "部分作品仅在特定地区上线，需要合适的网络环境与账号，字幕以英文或多语为主，适合有海外观看条件的用户。",
    tags: ["地区限定", "多语字幕"],
  },
  {
    name: "港台地区影音平台",
    category: "在线播放",
    region: "港台",
    stability: "中",
    desc: "提供以华语内容为主的点播服务，片库与大陆平台存在差异，有时能补足其他平台缺失的版本。",
    tags: ["华语", "点播"],
  },
  {
    name: "日韩内容聚合平台",
    category: "海外平台",
    region: "日韩",
    stability: "中",
    desc: "面向日韩影视内容的聚合站点，更新节奏较快，但版本与字幕质量参差不齐，需要自行甄别。",
    tags: ["更新快", "需甄别"],
  },
  {
    name: "影迷社区与讨论板块",
    category: "在线播放",
    region: "大陆",
    stability: "中",
    desc: "以影评、资源讨论帖为主，常有用户整理的观看线索与版本对比，适合作为查找方向的参考。",
    tags: ["讨论", "线索"],
  },
  {
    name: "网盘分享与聚合导航",
    category: "网盘下载",
    region: "大陆",
    stability: "低",
    desc: "资源更新最快，但链接极易失效且来源不一，安全性无法保证，请勿在陌生页面输入账号信息或下载可执行文件。",
    tags: ["易失效", "注意安全"],
  },
  {
    name: "短视频平台片段与合集",
    category: "在线播放",
    region: "大陆",
    stability: "中",
    desc: "常有解说与高光片段，适合快速了解内容风格，但通常不提供完整正片，只能作为预览。",
    tags: ["片段", "解说"],
  },
  {
    name: "字幕资源与外语版本",
    category: "网盘下载",
    region: "欧美",
    stability: "低",
    desc: "提供多语字幕与外语配音版本，便于对照观看，注意字幕与片源的时间轴是否匹配。",
    tags: ["字幕", "对照"],
  },
  {
    name: "数字商店购买与租借",
    category: "在线播放",
    region: "欧美",
    stability: "高",
    desc: "部分作品可在数字商店单集购买或限时租借，画质与版权最规范，适合想长期收藏的观众。",
    tags: ["购买", "正版"],
  },
  {
    name: "智能电视与大屏应用",
    category: "官方回看",
    region: "大陆",
    stability: "高",
    desc: "通过电视端的正规应用观看，适合家庭大屏场景，需先确认应用内片库是否包含该作品。",
    tags: ["大屏", "家庭"],
  },
  {
    name: "图书馆与机构数字资源",
    category: "在线播放",
    region: "欧美",
    stability: "高",
    desc: "部分地区图书馆提供正版影视库的在线访问权限，凭读者证即可使用，来源可靠且通常免费。",
    tags: ["正版", "免费"],
  },
];

export type Step = { step: string; title: string; desc: string; icon: string };

export const steps: Step[] = [
  {
    step: "01",
    title: "先明确使用场景",
    desc: "只是想在线看一遍，还是需要下载收藏、找完整版本？需求不同，合适的渠道完全不同。",
    icon: "ri-focus-3-line",
  },
  {
    step: "02",
    title: "用组合关键词搜索",
    desc: "标题 + 年份 / 全集 / 完整版 / 未删减，比只用标题命中更准确，也更容易筛掉无关结果。",
    icon: "ri-search-line",
  },
  {
    step: "03",
    title: "优先官方与正版渠道",
    desc: "先看视频平台与电视台客户端，再看社区与网盘；稳定性通常从高到低排列。",
    icon: "ri-shield-star-line",
  },
  {
    step: "04",
    title: "判断链接是否有效",
    desc: "留意页面的更新时间、评论反馈，以及是否要求强制安装软件——这是失效或风险资源的常见信号。",
    icon: "ri-link-m",
  },
  {
    step: "05",
    title: "失效就果断换渠道",
    desc: "不要在同一页面反复刷新或点击弹窗，直接切换到下一个渠道，通常比死磕一个来源更省时间。",
    icon: "ri-refresh-line",
  },
  {
    step: "06",
    title: "全程注意使用安全",
    desc: "不下载不明文件、不输入账号密码、不随意授权通知与权限，保持安全软件开启。",
    icon: "ri-lock-2-line",
  },
];

export type KeywordRow = { keyword: string; intent: string; advice: string };

export const keywordRows: KeywordRow[] = [
  {
    keyword: "继母的诱惑 在线看",
    intent: "想找可以直接播放的页面",
    advice: "优先打开正版平台与电视台客户端，聚合站点仅作补充。",
  },
  {
    keyword: "继母的诱惑 全集",
    intent: "不想一集一集地找",
    advice: "确认平台是否一次性放出全部内容，或是否提供合集入口。",
  },
  {
    keyword: "继母的诱惑 未删减版",
    intent: "想看更完整的版本",
    advice: "不同平台版本存在差异，以官方集数为准，谨慎对待来源不明的“完整版”。",
  },
  {
    keyword: "继母的诱惑 在哪看 平台",
    intent: "想知道正规观看入口",
    advice: "按平台类型逐一尝试，遵循先官方、后社区的顺序。",
  },
  {
    keyword: "继母的诱惑 资源 整理",
    intent: "想要一份汇总导航",
    advice: "参考本页资源导航，按渠道类型与稳定性进行筛选。",
  },
  {
    keyword: "继母的诱惑 网盘",
    intent: "想找可下载的资源",
    advice: "网盘来源混杂、失效频繁，仅作最后选择，务必注意安全。",
  },
];

export type VersionItem = { title: string; icon: string; desc: string };

export const versionItems: VersionItem[] = [
  {
    title: "全集 / 合集",
    icon: "ri-stack-line",
    desc: "指一次性提供全部剧集或内容合集，注意核对总集数是否完整，避免缺集。",
  },
  {
    title: "未删减版",
    icon: "ri-scissors-cut-line",
    desc: "指相较播出或平台版本更少剪辑的版本，但不同来源差异较大，真实性需要自行判断。",
  },
  {
    title: "清晰度等级",
    icon: "ri-hd-line",
    desc: "常见 480P / 720P / 1080P / 4K，清晰度越高越占带宽与存储，按设备与网络选择即可。",
  },
  {
    title: "字幕与配音",
    icon: "ri-translate-2",
    desc: "原声加字幕、国语配音、多语字幕等版本各有取舍，注意字幕时间轴是否对齐。",
  },
  {
    title: "播放源与线路",
    icon: "ri-route-line",
    desc: "同一内容可能提供多条播放线路，某条卡顿时可切换到其他线路继续观看。",
  },
];

export type Faq = { q: string; a: string };

export const faqs: Faq[] = [
  {
    q: "继母的诱惑在哪些平台可以看？",
    a: "建议按“官方平台 → 电视台客户端 → 社区与网盘”的顺序逐一尝试。由于不同平台的片库与地区版权会时常变化，具体请以平台内的搜索结果为准。",
  },
  {
    q: "有没有全集或者未删减版本？",
    a: "是否提供全集取决于平台本身；未删减版本在不同来源之间差异较大，建议以官方公布的内容为准，谨慎对待来源不明的“完整版”。",
  },
  {
    q: "为什么搜到的很多链接都打不开？",
    a: "资源链接尤其是网盘分享类很容易失效，加上部分站点更新不及时，就会产生大量死链。这属于常见现象，换渠道通常比反复刷新更有效。",
  },
  {
    q: "网盘资源为什么经常失效？",
    a: "分享链接可能因为违规、过期或被分享者主动取消而失效，而且来源无法核实，因此不建议把网盘作为首选的观看方式。",
  },
  {
    q: "免费渠道和正版渠道有什么区别？",
    a: "正版渠道更稳定、清晰度与字幕更规范，但部分内容可能需要会员；免费渠道更新快，但广告较多、稳定性差，并且可能存在安全风险。",
  },
  {
    q: "手机上观看要注意什么？",
    a: "优先使用正规应用的官方客户端，避免在浏览器中点击来源不明的下载按钮，也不要安装来路不明的应用。",
  },
  {
    q: "观看需要注册或者付费吗？",
    a: "这取决于渠道本身。正版平台通常需要注册，部分内容需要会员；第三方站点不应要求你填写敏感的账号或密码信息。",
  },
  {
    q: "画质应该怎么选择？",
    a: "手机或移动网络下 720P 通常已经足够，大屏或宽带环境下可选择 1080P 及以上，按设备与流量情况决定即可。",
  },
  {
    q: "一直找不到怎么办？",
    a: "可以扩大搜索范围，例如替换关键词组合、更换平台类型，或关注影迷社区中的更新线索，通常比死磕一个来源更省时间。",
  },
  {
    q: "观看时需要注意哪些安全事项？",
    a: "不下载可执行文件、不在陌生页面输入账号密码、不随意授权通知与权限，并保持操作系统与安全软件处于更新状态。",
  },
];

export type SafetyTip = { title: string; desc: string; icon: string };

export const safetyTips: SafetyTip[] = [
  {
    title: "警惕诱导安装",
    desc: "遇到“必须先下载播放器或 APP 才能观看”的提示要格外小心，其中不少捆绑了广告或无关程序。",
    icon: "ri-download-2-line",
  },
  {
    title: "不填敏感信息",
    desc: "不要在来源不明的页面输入账号、密码、手机号或验证码，正规平台也不会以这种方式索要。",
    icon: "ri-shield-keyhole-line",
  },
  {
    title: "谨慎对待弹窗",
    desc: "少点悬浮广告与突然弹出的窗口，它们常把页面跳转到无关站点，甚至触发连续跳转。",
    icon: "ri-window-2-line",
  },
  {
    title: "不装未知文件",
    desc: "不要运行来路不明的可执行文件，它是木马与病毒最常见的传播方式之一。",
    icon: "ri-virus-line",
  },
  {
    title: "关闭多余权限",
    desc: "对页面申请的浏览器通知、摄像头、麦克风等权限，按需拒绝，减少被打扰和被滥用的可能。",
    icon: "ri-notification-off-line",
  },
  {
    title: "保持系统更新",
    desc: "让浏览器、操作系统与安全软件保持最新，能有效降低被恶意程序影响的风险。",
    icon: "ri-loop-right-line",
  },
];